export default __webpack_public_path__ + "static/media/fm-1.ce16bef0.jpg";